import React, { useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "./schedule.css";
import UpcomingEvent from "../../components/UpcomingEvent/UpcomingEvent";
import UpcomingTask from "../../components/UpcomingTask/UpcomingTask";

const localizer = momentLocalizer(moment);
const MyCustomEvent = ({ event }) => (
  <div>
    <strong>{event.title}</strong>
    <p>{event.desc}</p>
  </div>
);
const Schedule = () => {
  const [date, setDate] = useState(new Date());
  const [view, setView] = useState("month"); // Manage view state (month or day)
  const events = [
    {
      title: "Event in February 2025",
      start: new Date(2025, 1, 15, 10, 0), // February 15, 2025, 10:00 AM
      end: new Date(2025, 1, 15, 12, 0), // February 15, 2025, 12:00 PM
      color: "#ffcccb", // Light red
    },
    {
      title: "Another Event in February 2025",
      start: new Date(2025, 1, 18, 14, 0), // February 20, 2025, 2:00 PM
      end: new Date(2025, 1, 20, 16, 0), // February 20, 2025, 4:00 PM
      color: "#90ee90", // Light green
    },
  ];

  const eventPropGetter = (event) => {
    const backgroundColor = event.color; // Use the color property from the event
    const style = {
      backgroundColor,
      borderRadius: "5px",
      color: "#000", // Text color
      border: "none",
    };
    return {
      style,
    };
  };

  // Custom navigation
  const CustomToolbar = (toolbar) => {
    const { date, onNavigate } = toolbar;

    // Format the current date to display as "Feb 2025"
    const formattedDate = moment(date).format("MMM YYYY");

    const goToPrevious = () => {
      onNavigate("PREV");
    };

    const goToNext = () => {
      onNavigate("NEXT");
    };

    return (
      <div className="custom_toolbar">
        <button className="btn_primary">+ Add Schedule</button>
        <div className="d-flex align-items-center ">
          <button onClick={goToPrevious} className="btn_arrow">
            <i class="fas fa-angle-left"></i>
          </button>
          <span
            style={{ margin: "0 20px", fontSize: "21px", fontWeight: "500" }}
          >
            {formattedDate}
          </span>
          <button onClick={goToNext} className="btn_arrow">
            <i class="fas fa-angle-right"></i>
          </button>

          {view === "week" && (
            <button
              className="btn_border ms-4 px-4"
              onClick={() => setView("month")}
            >
              Back
            </button>
          )}
        </div>
      </div>
    );
  };

  const CustomWeekHeader = ({ label }) => (
    <div
      style={{
        color: "white",
        backgroundColor: "#007bff",
        padding: "5px",
        fontWeight: "bold",
      }}
    >
      {label}
    </div>
  );
  const handleDateClick = (selectedDate) => {
    setDate(selectedDate);
    setView("week");
    console.log("ji");
  };
  return (
    <>
      <div className="schedule p-40">
        <div className="row">
          <div className="col-md-8">
            <Calendar
              localizer={localizer}
              events={events}
              startAccessor="start"
              endAccessor="end"
              date={date}
              view={view}
              onView={setView}
              selectable // Allows selecting a date to go to agenda
              views={{ month: true, agenda: true, week: true }} // Enable only month & day views
              onNavigate={setDate}
              onSelectSlot={(slotInfo) => handleDateClick(slotInfo.start)} // Click to switch to day view
              components={{
                event: MyCustomEvent,
                toolbar: CustomToolbar,
                timeGutterHeader: () => null, // Hide the time gutter header
                timeGutter: () => null, // Hide the time gutter
                monthHeader: CustomWeekHeader,
              }}
              style={{ height: "600px" }}
              eventPropGetter={eventPropGetter}
            />
          </div>
          <div className="col-md-4">
            <UpcomingEvent />
            <div className="mt-3">
              <UpcomingTask />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Schedule;
